import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditDepartment = ({depId, list}) => {
    const [departmentData, setDepartmentData] = useState(null);

    const fetchDepartment = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department/${Id}`)
            .then(response => {
                setDepartmentData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setDepartmentData([]); 
            });
    }

    useEffect(() => {
        if (depId) {
            fetchDepartment(depId);
        }
    },[depId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (departmentData) {
            reset(departmentData);
        }
    }, [departmentData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/department/${depId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_department_${depId}`);
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
            });
    }

    if (!depId || !departmentData) {
        return null;
    }

    return (
        <div id={`edit_department_${depId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Department</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-block mb-3">
                                <label className="col-form-label">Department Name <span className="text-danger">*</span></label>
                                <input className="form-control" type="text" defaultValue={departmentData.name} {...register('name')}/>
                                <div className="text-sm text-danger">
                                    {errors.name && <p>{errors.name.message}</p>}
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditDepartment
